import React from 'react';

import { strings } from 'APP_ROOT/localization';

import RemoveSharedRavenModal from 'APP_ROOT/components/pages/account/removeSharedRavenModal';

const lookupAccessLevelLabel = accessLevel => {
    return typeof accessLevel === 'string' && (
        strings[`mo_users_access_level_label_${accessLevel.toLowerCase()}`] || strings.mo_users_access_level_label_other
    );
};

const getVehicleName = vehicle => {
    return vehicle && vehicle.name
};

const getOwnerEmail = users => {
    if (!users) return '';
    const owner = users.find(u => u.accessLevel === 'OWNER');
    return owner ? owner.email : '';
};

export default class GuestUserAccessPage extends React.PureComponent {

    state = {
        removeSharedRavenModalOpen: false
    }

    openRemoveSharedRavenModal = (e) => {
        e.preventDefault();
        document.documentElement.classList.add("no-scroll");
        this.setState({
            removeSharedRavenModalOpen: true
        });
    }

    closeRemoveSharedRavenModal = (e) => {
        e.preventDefault();
        document.documentElement.classList.remove("no-scroll");
        this.setState({
            removeSharedRavenModalOpen: false
        });
    }

    render() {
        const { raven, user } = this.props;

        const vehicleName = getVehicleName(raven.vehicle);
        const accessLevelLabel = lookupAccessLevelLabel(raven.accessLevel);
        const ownerEmail = getOwnerEmail(raven.ravenUsers);

        return (
            <div className="mobile-users-page container">
                <div className="row">
                    <div className="col">
                        <h2>
                            <i className="material-icons">supervised_user_circle</i>
                            {strings.mobile_guest_user_access_title}
                        </h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <p>{strings.formatString(strings.mobile_guest_user_access_you_have_x_level_access_to_raven_x, accessLevelLabel, vehicleName)}</p>
                        <p>{strings.mobile_guest_user_access_granted_by} <b>{ownerEmail}</b></p>
                    </div>
                </div>
                <div className="row">
                    <div className="col text-right">
                        <button
                            className="btn btn-secondary"
                            onClick={this.openRemoveSharedRavenModal}
                        >
                            <i className="material-icons">remove_circle_outline</i>
                            {strings.remove_raven}
                        </button>
                        <RemoveSharedRavenModal
                            raven={raven}
                            user={user}
                            removeSharedRavenModalOpen={this.state.removeSharedRavenModalOpen}
                            closeRemoveSharedRavenModal={this.closeRemoveSharedRavenModal}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
